"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Wrapper = exports.Item = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _Text = _interopRequireDefault(require("../Text/Text"));

var _excluded = ["children"];

var Wrapper = _styledComponents["default"].ul.withConfig({
  displayName: "List__Wrapper",
  componentId: "sc-an1nsk-0"
})(["padding:0;list-style:none;", " ", " ", " ", " ", " & > li{display:flex;align-items:flex-start;margin-bottom:", ";&:last-child{margin-bottom:0;}::before{margin-top:", "px;margin-right:", "px;flex-shrink:0;content:\"\";display:inline-block;border-radius:50%;height:8px;width:8px;background-color:", ";}}"], _styledSystem.width, _styledSystem.space, _styledSystem.height, _styledSystem.fontSize, _styledSystem.fontFamily, function (_ref) {
  var spacing = _ref.spacing;
  return spacing;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[1];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[3];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[5];
});

exports.Wrapper = Wrapper;

var Item = function Item(_ref5) {
  var children = _ref5.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], props, children);
};

exports.Item = Item;
Item.propTypes = {
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].string
};
Item.defaultProps = {
  as: "li"
};
Wrapper.defaultProps = {
  spacing: "24px"
};